import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TriOptionActionTypeEnum } from '../../models/tri-option-dialog.model';

export class TriOptionConfirmationDialogData {
  header: string = 'Are you sure?';
  cancelMessage: string;
  discardMessage: string;
  saveMessage: string;
  showConflict: boolean = false;
  conflictMessage: string;
  cancelActionText: string = 'Cancel';
  confirmDiscardText: string = 'Discard';
  confirmSaveActionText: string = 'Save';
  confirmSaveButtonColor: string = 'warn';
  disableDiscardButton: boolean = false;
  disableSaveButton: boolean = false;
}

@Component({
  selector: 'sd-tri-option-confirmation-dialog',
  templateUrl: './tri-option-confirmation-dialog.component.html',
  styleUrls: ['./tri-option-confirmation-dialog.component.scss']
})
export class TriOptionConfirmationDialogComponent implements OnInit {
  triOptionActionTypeEnum = TriOptionActionTypeEnum;
  constructor(@Inject(MAT_DIALOG_DATA) public data: TriOptionConfirmationDialogData) {}

  ngOnInit() {
    this.data = {
      ...new TriOptionConfirmationDialogData(),
      ...this.data
    };
  }
}
